import { Injectable, OnInit } from '@angular/core';
import firebase from 'firebase';

@Injectable({
    providedIn: 'root'
})
export class AuthService implements OnInit {

    isAuth: boolean;

    constructor() {
    }

    ngOnInit(): void {
        this.isAuthFromServer();
    }

    /**
     * Se connecter avec un email et le mot de passe avec l'API de firebase
     * @param email 
     * @param password 
     * @returns 
     */
    signInUser(email: string, password: string): Promise<any> {
        return firebase.auth().signInWithEmailAndPassword(email, password)
            .then((userCredential) => {
                this.isAuth = true;
            })
            .catch((error) => {
                console.log(error.message);
            }
        );
    }

    /**
     * Se deconnecter avec l'API de firebase
     */
    signOutUser() {
        firebase.auth().signOut().then(
            () => {
                this.isAuth = false;
            }
        );
    }

    /**
     * retourner l'email de l'utilisateur
     */
    getCurrentUserEmail(): Promise<string> {
        return new Promise(
            (resolve, reject) => {
                const email = firebase.auth().currentUser?.email;
                if(email !== null) {
                    resolve(<string>email);
                } else {
                    reject("Impossible de trouver l'email");
                }
            }
        );
    }

    isAuthFromServer() {
        return firebase.auth().onAuthStateChanged(
            (user) => {
                if(user) {
                    this.isAuth = true;
                    return true;
                } else {
                    console.log('pas connecté');
                    this.isAuth = false;
                    return false;
                }
            },
            (error) => {
                console.log(error.message);
            }
        );
    }
}
